export default __webpack_public_path__ + "static/media/3.dfce8e3e.jpg";